export default "__VITE_ASSET__DtyM0xfn__"